import axios, { type AxiosRequestConfig } from 'axios';

const axiosInstance = axios.create({
	baseURL: `${import.meta.env.VITE_CHAT_API}api/internal/v1/`,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Credentials': 'true'
	}
});

const api = {
	get<T>(
		url: string,
		params?: Record<string, unknown>,
		config?: AxiosRequestConfig
	): Promise<T> {
		return axiosInstance
			.get(url, { params, ...config })
			.then((response) => response.data);
	},
	post<T>(
		url: string,
		data?: unknown,
		config?: AxiosRequestConfig
	): Promise<T> {
		return axiosInstance
			.post(url, data, config)
			.then((response) => response.data);
	},
	put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
		return axiosInstance
			.put(url, data, config)
			.then((response) => response.data);
	},
	delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
		return axiosInstance.delete(url, config).then((response) => response.data);
	},
	patch<T>(
		url: string,
		data?: unknown,
		config?: AxiosRequestConfig
	): Promise<T> {
		return axiosInstance
			.patch(url, data, config)
			.then((response) => response.data);
	}
};

export default api;
